import {
  endOfISOWeek,
  endOfYear,
  format,
  getISOWeekYear,
  isAfter,
  max,
  min,
  setISOWeek,
  startOfISOWeek,
  startOfYear,
} from 'date-fns';

const formatDayRange = (firstDay: Date, lastDay: Date) =>
  `${format(firstDay, 'EEE dd')} - ${format(lastDay, 'EEE P')}`;

const getIsoWeek = (isoWeekYear: number, week: number) => {
  const weekDate = setISOWeek(new Date(isoWeekYear, 0, 4), week);
  return {
    exists: getISOWeekYear(weekDate) === isoWeekYear,
    start: startOfISOWeek(weekDate),
    end: endOfISOWeek(weekDate),
  };
};

const getCalendarYearWeekRanges = (year: number, week: number) => {
  const yearStart = startOfYear(new Date(year, 0, 1));
  const yearEnd = endOfYear(yearStart);
  const neighbourIsoWeekYears = [year - 1, year, year + 1];

  return neighbourIsoWeekYears.reduce<string[]>((acc, isoWeekYear) => {
    const isoWeek = getIsoWeek(isoWeekYear, week);
    const firstDay = max([isoWeek.start, yearStart]);
    const lastDay = min([isoWeek.end, yearEnd]);
    const isInCalendarYear = isoWeek.exists && !isAfter(firstDay, lastDay);

    if (isInCalendarYear) {
      acc.push(formatDayRange(firstDay, lastDay));
    }
    return acc;
  }, []);
};

/**
 * Returns the days a statistics row holds. The API groups on a calendar year and an ISO week number,
 * so a row can span two ranges around New Year.
 */
export const getWeekYearLabel = (year: string, week: string): string => {
  const yearNumber = Number(year);
  const weekNumber = Number(week);
  const isValidWeek = yearNumber > 0 && weekNumber > 0;

  return isValidWeek ? getCalendarYearWeekRanges(yearNumber, weekNumber).join(', ') : '';
};
